module.exports = __webpack_public_path__ + "img/component.d0738c40.svg";